export enum ShipmentEventSource {
  /** Carrier updates that come through integrations */
  CAPACITY_PROVIDER = 'CAPACITY_PROVIDER',
  CONDUIT = 'CONDUIT',
  SYSTEM = 'SYSTEM',
  USER = 'USER',
  /** Carrier updates that are manually made through the carrier portal */
  CARRIER_PORTAL = 'CARRIER_PORTAL',
}
